<template>
    <article class="app-product-option" :class="`app-product-option--type-${designType}`">
        <img v-if="bgImgUrl" :src="require(`@/assets/img/${bgImgUrl}`)" alt="" class="app-product-option__bg-img d-none d-sm-block">
        <div class="app-product-option__inner row align-items-start justify-content-center justify-content-sm-end">
            <div class="app-product-option__preview col">
                <span v-if="headlineNote" class="app-product-option__headline-note d-block" v-html="headlineNote"></span>
                <b v-if="headline" class="app-product-option__headline" v-html="headline"></b>
                <p v-if="previewText" class="app-product-option__preview-text" v-html="previewText"></p>
                <ul v-if="list" class="app-product-option__list">
                    <li v-for="(item, idx) in list" :key="idx" class="app-product-option__list-item" v-html="item"></li>
                </ul>
                <!--
                <button v-if="previewTriggerText" type="button" class="app-product-option__preview-trigger-btn">{{ previewTriggerText }}</button>
                -->
            </div>
            <div class="app-product-option__price-box col-12 col-sm-auto">
                <b v-if="inclusive" class="app-product-option__price">{{ $t('misc.inclusive') }}</b>
                <b v-else-if="price > 0" class="app-product-option__price">
                    <!-- BEWARE: trailing/same line span intended to avoid whitespace with prices without month suffix -->
                    {{ nEnhanced(price, 'currency') }}<span v-if="priceFormat === constants.priceFormats.monthly" class="app-price-calculation-view__total-price-tag-suffix"> / {{ $t('misc.perMonth') }}</span>
                </b>
                <b v-else class="app-product-option__price">{{ $t('misc.priceOnRequest') }}</b>
                <input type="checkbox" :checked="value" @change="$emit('input', $event.target.checked)" class="app-product-option__checkbox">
            </div>
        </div>
    </article>
</template>

<script>
import constants from '@/mixins/constants'

export default {
    name: 'ProductOption',
    mixins: [constants],
    computed: {
        priceFormat: (vm) => vm.$store.state.priceFormat
    },
    props: {
        value: Boolean,
        headlineNote: String,
        headline: String,
        previewText: String,
        previewTriggerText: {
            type: String,
            default: 'Details anzeigen'
        },
        list: Array,
        price: Number,
        inclusive: Boolean,
        bgImgUrl: String,
        designType: {
            type: String,
            default: '1'
        }
    }
}
</script>

<style scoped>
    .app-product-option {
        position: relative;
        border-bottom: 2px solid #e6e6e6;
        background-color: #fff;
        overflow: hidden;
    }
    .app-product-option__bg-img {
        position: absolute;
        top: 0;
        right: 0;
    }
    .app-product-option__inner {
        margin-top: -20px;
        margin-left: -8px;
        margin-right: -8px;
        padding: 15px;
    }
    .app-product-option--type-2 .app-product-option__inner {
        padding-top: 20px;
        padding-bottom: 30px;
    }
    .app-product-option__preview,
    .app-product-option__price-box {
        padding-left: 8px;
        padding-right: 8px;
    }
    .app-product-option__preview {
        min-width: 270px;
        padding-top: 20px;
    }
    .app-product-option__headline {
        font-size: 1em;
    }
    .app-product-option--type-2 .app-product-option__headline {
        font-size: 1.5em;
    }
    .app-product-option__headline-note {
        margin-bottom: .2em;
        color: #969492;
    }
    .app-product-option--type-2 .app-product-option__headline-note {
        margin-bottom: 2em;
    }
    .app-product-option__preview-text {
        color: #969492;
    }
    .app-product-option__list {
        padding: 0;
        list-style: none;
        color: #545454;
    }
    .app-product-option__list-item {
        position: relative;
        margin-bottom: .6em;
        padding: 0 0 .4em 18px;
        border-bottom: 1px solid #e6e6e6;
    }
    .app-product-option__list-item::before {
        content: '•';
        position: absolute;
        left: 2px;
        top: 0;
    }
    .app-product-option__list-item:last-child {
        margin-bottom: 0;
    }
    /*.app-product-option__preview-trigger-btn {
        margin: -.5em;
        padding: .5em;
        font-size: 1em;
        font-weight: 700;
        color: #f96915;
        border: 0;
        background: transparent;
    }*/
    .app-product-option__price-box {
        flex: 1 0 240px;
        padding-top: 20px;
        text-align: right;
        white-space: nowrap;
    }
    .app-product-option__price {
        margin-right: 20px;
        color: #f96915;
    }

    @media ( min-width: 576px ) {
        .app-product-option--type-2 {
            min-height: 180px;
        }
        .app-product-option__bg-img {
            width: auto;
            height: 100%;
        }
        .app-product-option__price-box {
            flex-grow: 0;
        }
        .app-product-option--type-2 .app-product-option__price {
            color: #fff;
        }
    }
    @media ( min-width: 768px ) {
        .app-product-option--type-2 {
            min-height: 200px;
        }
        .app-product-option__inner {
            margin-left: -15px;
            margin-right: -15px;
            padding: 25px;
        }
        .app-product-option--type-2 .app-product-option__inner {
            padding-top: 25px;
            padding-bottom: 40px;
        }
        .app-product-option__preview,
        .app-product-option__price-box {
            padding-left: 15px;
            padding-right: 15px;
        }
        .app-product-option__price-box {
            flex-basis: 38%;
        }
    }
</style>
